import Select from "react-select";

const CustomReactSelect = ({ field, form, options, value, onChange, ...props }) => {
  const selectedValue = value 
    ? options.find((option) => option.value === value) 
    : options.find((option) => option.value === field?.value) || null;

  return (
    <Select
      {...props}
      options={options}
      value={selectedValue}
      onChange={(selectedOption) => {
        form.setFieldValue(field.name, selectedOption ? selectedOption.value : "");
        if (onChange) {
          onChange(selectedOption?.value); // ✅ Executes external function if provided
        }
      }}
      styles={{
        control: (provided) => ({
          ...provided,
          borderColor: "#aaaaaa",
          fontSize:14,
          "&:hover": { borderColor: "#aaaaaa" },
        }),
        dropdownIndicator: (provided) => ({
          ...provided,
          color: "#aaaaaa",
        }),
        menu: (provided) => ({
          ...provided,
          maxHeight: "300px",
          overflowY: "auto",
        }),
      }}
    />
  );
};

export default CustomReactSelect;
